import { BackendAPI } from "../../../axios";
import axios from 'axios';

const getRefreshToken = async () => {
  try {
    const response = await BackendAPI.get("/user/refresh-token", {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
   // console.error(error);
    if (axios.isAxiosError(error)) {
        if (error.request.status == 401) {
          window.location.reload();
        }
      }
  }
};


 export const createTicket = async (
  ticket: any,
  files: any[],
  username: string|undefined
) => {

  const bearerToken = await getRefreshToken();

  if (!bearerToken) {
    throw new Error("Unable to get access token");
  }

  const ticketRequest = {
    ...ticket,
    username: username,
  };

  const formData = new FormData();

  formData.append(
    "ticket",
    JSON.stringify(ticketRequest)
  );

  files.forEach((file) => {
    formData.append("files", file.originFileObj);
  });
console.log(ticketRequest);
  const response = await BackendAPI.post(
    "/ticket/create",
    formData,
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    }
  );
  console.log(response);
  return response.data;
};

export interface GetMyTicketsRequest {

    page: number;

    size: number;

    search?: string;

    status?: string;

    ticketType?: string;

    category?: string;

    environment?: string;

    sortBy?: string;

    sortDir?: "asc" | "desc";

}

export const getMyTickets = async (
    params: GetMyTicketsRequest
) => {

    const bearerToken = await getRefreshToken();

    const response = await BackendAPI.get(
        "/ticket/viewtickets",
        {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
            },

            params: {

                page: params.page,

                size: params.size,

                search: params.search,

                status: params.status,

                category: params.category,

                environment: params.environment,

                sortBy: params.sortBy,

                sortDir: params.sortDir,

            },
        }
    );

    return response.data;
};

export const getTicketCounts = async () => {

    const bearerToken = await getRefreshToken();

    const response = await BackendAPI.get(
        "/ticket/count",
        {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
            },
        }
    );
    console.log(response.data);
    return response.data;
};

export const getTicketDetails = async (
    ticketId: number |string
) => {

    const bearerToken = await getRefreshToken();

    const response = await BackendAPI.get(

        `/ticket/${ticketId}`,

        {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
            },
        }
    );

    return response.data;
};

export const downloadTicketAttachment = async (
    attachmentId: number
) => {

    const bearerToken = await getRefreshToken();

    return BackendAPI.get(

        `/attachment/ticket/${attachmentId}`,

        {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
            },
            responseType: "blob",
        }
    );

};
export const downloadCommentAttachment = async (
    attachmentId: number
) => {

    const bearerToken = await getRefreshToken();

    return BackendAPI.get(

        `/attachment/comment/${attachmentId}`,

        {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
            },
            responseType: "blob",
        }
    );

};

export const addComment = async (
    ticketId: number|null|string,
    values: any,
    files: any[]
) => {

    const bearerToken = await getRefreshToken();

    const formData = new FormData();

    formData.append(
        "comment",
        JSON.stringify({
            comment: values.comment,
            status: values.status,
        })
    );

    files.forEach(file => {
        formData.append("files", file.originFileObj);
    });

    const response = await BackendAPI.post(
        `/ticket/${ticketId}/comment`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
                "Content-Type": "multipart/form-data",
            },
        }
    );

    return response.data;
};

export const getCategories = async () => {
     const bearerToken = await getRefreshToken();
    const response = await BackendAPI.get("/ticket/ticket-category",
        {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
            },
        }
    );
    return response.data;
};